<div role="dialog" aria-labelledby="dialogTitle" >
  <div class="modal-header">
    <h2 id="dialogTitle" class="modal-title module-title">{{"plan.settings"|translate}}</h2>
    <button [disabled]="!_enableCancel" type="button" value="Close" class="close" aria-label="Close" (click)="dismiss()" title="{{'dialog.box.close.tooltip'|translate}}">
      <esp-icon name="x"></esp-icon>
    </button>
  </div>
  <div class="modal-body">
    <wfm-plan-loading-overlay *ngIf="_isLoading"></wfm-plan-loading-overlay>
    <div class="col-16">
      <form [formGroup]="planSettingsForm" (submit)="submit()">
        
        <div>
          <div class="row">
            <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
              <h3 id="patienceTimeSectionLabel" class="section-title mt-0">
                {{"plan.settings.patience.time.title" | translate}}
              </h3>
            </div>
          </div>
          <div class="row">
            <div class='col-sm-12'>
                <div class="checkbox sm-left-pad">
                  <input type="checkbox" formControlName="usePatienceTime" id="patienceTimeSetting" name="patienceTime" value="enable" [attr.aria-labelledby]="'patienceTimeSectionLabel patienceTimeCheckboxLabel'" (change)="onUsePatienceTime($event)">
                  <label id="patienceTimeCheckboxLabel" for="patienceTimeSetting">{{"plan.settings.patience.time.checkbox" | translate}}</label>
                  <span class="inline-input">
                    <p-inputnumber formControlName="medianPatienceTime"
                      mode="decimal"
                      [useGrouping]="false"
                      [maxlength]="_maxLenMpt"
                      name="patienceTimeInput"
                      inputId="patienceTimeInput"
                      styleClass="mpt-input"
                      [ariaLabelledBy]="'patienceTimeSectionLabel'"
                      [ariaDescribedBy]="'patienceTimeUnit'"
                      autocomplete="off"
                      (onInput)="mptOnInput($event)"
                    >
                    </p-inputnumber> <span id="patienceTimeUnit">{{"plan.settings.unit.seconds" | translate}}</span>
                  </span>
                  <button type="button" class="info-tooltip" [attr.aria-label]="'icon.info.tooltip' | translate" [attr.aria-describedby]="'patienceTimeInfoDesc'" placement="right" ngbPopover="{{'plan.settings.patience.time.tooltip' | translate}}" popoverClass="popover-tooltip" container="body" triggers="click" [autoClose]="true" #patiencePopover="ngbPopover" (shown)="onInfoPopoverShown(patiencePopover)"><esp-icon name="info"></esp-icon></button>
                  <span id="patienceTimeInfoDesc" class="sr-only">{{'plan.settings.patience.time.tooltip' | translate}}</span>
                </div>
                <div *ngIf="_showPatienceTimeValidationError" class="error-message">{{'validation.err.patience.time.input'|translate}}</div>
            </div>
          </div>
          <div class="row">
            <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
              <h3 id="calcMethodSectionLabel" class="section-title">
                {{"plan.settings.calculation.mode.title" | translate}}
              </h3>
            </div>
          </div>
          <div class="row">
            <div class='col-sm-12'>
              <div role="radiogroup" aria-labelledby="calcMethodSectionLabel">
                <div class="radio">
                  <input type="radio" formControlName="ctDistributionCalcMethod" name="ctDistributionCalcMethod" id="MUToCT" value="MU_CT_DISTRIBUTION" aria-controls="fteRequiredWarning">
                  <label for="MUToCT">
                    {{"plan.settings.mu.ct.dist" | translate}}
                  </label>
                  <button type="button" class="info-tooltip" [attr.aria-label]="'icon.info.tooltip' | translate" [attr.aria-describedby]="'muCtDistInfoDesc'" placement="right" ngbPopover="{{'plan.settings.mu.ct.dist.tooltip' | translate}}" popoverClass="popover-tooltip" container="body" triggers="click" [autoClose]="true" #muCtDistPopover="ngbPopover" (shown)="onInfoPopoverShown(muCtDistPopover)"><esp-icon name="info"></esp-icon></button>
                  <span id="muCtDistInfoDesc" class="sr-only">{{'plan.settings.mu.ct.dist.tooltip' | translate}}</span>
                </div>
                <div class="radio">
                  <input type="radio" formControlName="ctDistributionCalcMethod" name="ctDistributionCalcMethod" id="FTERequired" value="FTE_REQUIRED" aria-controls="fteRequiredWarning">
                  <label for="FTERequired">
                    {{"plan.settings.fte.required" | translate}}
                  </label>
                  <button type="button" class="info-tooltip" [attr.aria-label]="'icon.info.tooltip' | translate" [attr.aria-describedby]="'fteRequiredInfoDesc'" placement="right" ngbPopover="{{'plan.settings.fte.required.tooltip' | translate}}" popoverClass="popover-tooltip" container="body" triggers="click" [autoClose]="true" #fteRequiredPopover="ngbPopover" (shown)="onInfoPopoverShown(fteRequiredPopover)"><esp-icon name="info"></esp-icon></button>
                  <span id="fteRequiredInfoDesc" class="sr-only">{{'plan.settings.fte.required.tooltip' | translate}}</span>
                </div>


              </div>
            </div>
          </div>
          <div class="row">
            <div class='col-sm-12'>
              <div id="fteRequiredWarning" role="status" aria-live="polite" aria-atomic="true">
                <div class="embedded-warning patience" *ngIf="displayFTEWarning">
                  <esp-icon class="embedded-icon" name="warning"></esp-icon>
                  {{"plan.settings.fte.required.warning" | translate}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [showTooltip]="false"
                     [isSecondary]="true"
                     [isDisabled]="!_enableCancel"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.submit.btn'|translate}}"
                     id="accept-btn"
                     [showTooltip]="false"
                     [isPrimary]="true"
                     [isDisabled]="!_enableAccept"
                     (clicked)="submit()"></breeze-button>
    </div>
  </div>
</div>
<p-toast position="bottom-center">
</p-toast>
